import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState } from "react";
import Wrapper from "../wrapper/Wrapper";
import { Container, Row, Col } from "react-bootstrap";
import { AccountRail } from "./AccountRail";
import MyAccount from "./MyAccount";
import AccountOrders from "./AccountOrders";
import AccountOrdersV2 from "./AccountOrdersV2";
import AccountFavorites from "./AccountFavorites";
import { AccountSettings } from "./AccountSettings";
import MyAccountTab from "./MyAccountTab";
import { useFlags } from 'launchdarkly-react-client-sdk';
export var Account = function Account(props) {
  var flags = useFlags();
  var useAccountOrdersV2 = flags['releaseAccountOrdersV2'] ? flags['releaseAccountOrdersV2'] : false;
  var store = props.store,
      _props$account = props.account,
      account = _props$account === void 0 ? {} : _props$account,
      _props$logout = props.logout,
      logout = _props$logout === void 0 ? function () {
    return console.log("Logout flow");
  } : _props$logout,
      _props$handleEditProf = props.handleEditProfileClick,
      handleEditProfileClick = _props$handleEditProf === void 0 ? function () {
    return console.log("Edit profile flow");
  } : _props$handleEditProf,
      _props$handlePassword = props.handlePasswordReset,
      handlePasswordReset = _props$handlePassword === void 0 ? function () {
    return console.log("Password profile flow");
  } : _props$handlePassword,
      myAccountTabModel = props.myAccountTabModel;

  var AccountOrderComponent = function AccountOrderComponent() {
    if (useAccountOrdersV2) {
      return /*#__PURE__*/React.createElement(AccountOrdersV2, _extends({
        account: account,
        store: store
      }, props));
    }

    return /*#__PURE__*/React.createElement(AccountOrders, _extends({
      account: account,
      store: store
    }, props));
  };

  var links = [{
    label: "My Account",
    labelOverride: "Account",
    customClass: "cb-account-body--account",
    page: "",
    component: /*#__PURE__*/React.createElement(MyAccountTab, {
      store: store,
      myAccountTabModel: myAccountTabModel,
      handlePasswordReset: handlePasswordReset,
      handleEditProfileClick: handleEditProfileClick,
      accountInfo: account
    })
  }, {
    label: "Orders",
    customClass: "cb-account-body--orders",
    page: "/my-orders",
    component: AccountOrderComponent()
  }, {
    label: "Favorites",
    customClass: "cb-account-body--favorites",
    page: "/favorites",
    component: /*#__PURE__*/React.createElement(AccountFavorites, {
      account: account,
      store: store
    })
  } // { label: "Settings",  page: '', component: <AccountSettings account={account}/> }
  ];
  var components = links.map(function (link) {
    return link.component;
  });
  var customClasses = links.map(function (link) {
    return link.customClass;
  });
  var page = typeof window !== "undefined" ? window.location.href : null;
  var pageIndex = 0;

  if (page) {
    var index = links.findIndex(function (item) {
      return page.includes(item.label.toLocaleLowerCase());
    });
    pageIndex = index;
  }

  if (pageIndex <= -1) {
    pageIndex = 0;
  } // pageIndex = 1;


  var _useState = useState(pageIndex),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: "cb-account new-cb-account"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "2",
    className: "p-0 new-cb-account__col-rail"
  }, /*#__PURE__*/React.createElement(AccountRail, {
    account: account,
    logout: logout,
    links: links,
    show: setCurrent,
    activeIndex: current
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "10",
    className: "cb-account-body ".concat(customClasses[current])
  }, components[current]))));
};